import React from 'react'
import { useTranslation } from 'react-i18next';
import { useKato } from '../../../../contexts/kato.context';
import classes from './styles.module.scss';
import { ILargeLandowners } from '../../../../types/screening.types';
import Card from '../../../../components/card/card.component';
import { Bar, BarChart, CartesianGrid, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { useUser } from '../../../../contexts/user.context';

const baseClass = 'land-fund-tab';
const translationKey = 'screening.land-fund';

const headers: (keyof ILargeLandowners)[] = [
    'name',
    'total_land',
    'total_arable',
    'total_pasture',
    'fact_land',
    'fact_arable',
    'fact_pasture',
]

const LandFundTab = () => {
    const { t } = useTranslation();
    const { landFund } = useKato().screeningInfo;
    const { isModulePresent } = useUser();

    const { landFundItems, largeLandowners } = landFund || {};

    const barData = landFundItems ? [
        {
            name: t(`${translationKey}.land-fund-items.settlement-land`),
            value: landFundItems.settlementLand,
        },

        {
            name: t(`${translationKey}.land-fund-items.agricultural-land`),
            arable: landFundItems.agricultural_arable,
            pasture: landFundItems.agricultural_pasture,
        },
        {
            name: t(`${translationKey}.land-fund-items.reserve-land`),
            arable: landFundItems.reserve_arable,
            pasture: landFundItems.reserve_pasture,
        },
        {
            name: t(`${translationKey}.land-fund-items.other-land`),
            value: landFundItems.otherLand,
        },
    ] : []


    if (!landFund) return null;
    return (
        <div className={classes[baseClass]}>
            {largeLandowners && largeLandowners.length > 0 && isModulePresent('large-landowners') && (
                <Card title={t(`${translationKey}.large-landowners.title`)}>
                    <div className={classes[`${baseClass}__table`]}>
                        <table>
                            <thead>
                                <tr>
                                    {headers.map((header) => (
                                        <th key={header}>{t(`${translationKey}.large-landowners.${header}`)}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {largeLandowners.map((owner, index) => (
                                    <tr key={index}>
                                        {
                                            headers.map((header) => (
                                                <td key={header}>
                                                    {header === 'name' ? owner.name : owner[header]?.toLocaleString()}
                                                </td>
                                            ))
                                        }
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Card>
            )}
            {landFundItems && isModulePresent('land-fund-items') && <Card title={t(`${translationKey}.land-fund-items.title`)}>
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={barData} barGap={-120} barCategoryGap={70} margin={{ top: 20, right: 20, left: 20, bottom: 20 }}>
                        <CartesianGrid vertical={false} horizontal={true} />
                        <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                            fontSize: '0.625rem',
                            fill: '#818689',
                        }} />
                        <YAxis hide />
                        <Bar dataKey="value" fill="#118F84" radius={[4, 4, 0, 0]} isAnimationActive={false}>
                            <LabelList
                                dataKey="value"
                                position="insideTop"
                                style={{ fill: 'white', fontWeight: 600 }}
                                formatter={(val) => val?.toString() !== '0' ? val?.toLocaleString() : ''}
                            />
                        </Bar>

                        <Bar dataKey="arable" stackId="agricultural" fill="#118F84" isAnimationActive={false}>
                            <LabelList position="insideTop" style={{ fill: 'white', fontWeight: 600 }} formatter={(val) => val ? val?.toLocaleString() : ''} />
                        </Bar>
                        <Bar dataKey="pasture" stackId="agricultural" fill="#92D050" isAnimationActive={false} radius={[4, 4, 0, 0]}>
                            <LabelList position="insideTop" style={{ fill: 'white', fontWeight: 600 }} formatter={(val) => val ? val?.toLocaleString() : ''} />
                        </Bar>

                        <Tooltip
                            cursor={{ fill: 'transparent' }}
                            formatter={(value: number, key: string) => {
                                const translated = t(`${translationKey}.land-fund-items.${key}`);
                                return [value.toLocaleString('ru-RU'), translated];
                            }}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </Card>}
        </div>
    )
}

export default LandFundTab